import React, { useEffect, useState } from 'react';
import { DropDownComponent } from "../../dropdown/DropDownComponent"
import { PlaceHolder } from "../../constants/PlaceHolderConstants"
import { PhoneNumberComponent } from '../../dropdown/PhoneNumberComponent';
import CompanyDocuments from "../../components/companyMaster/CompanyDocuments";
import CompanyCurrency from "../../components/companyMaster/CompanyCurrency";
import AdditionalContact from "../../components/companyMaster/AdditionalContact";
import AddNewContactModal from "../../components/companyMaster/AddNewContactModal";
import FetchData from "../../providers/dataProvider";

const CompanyDetails = ({
    HandleFormChange,
    formValues,
    countrydata,
    currencydata,
    designationdata,
    currency,
    setCurrency,
    HandleCurrencyChange,
    HandleCountryChange,
    HandleDesignationChange,
    designation,
    HandleImageFileChange,
    DeleteImage,
    showImage,
    condepartment,
    HandleConDesChange,
    condesignation,
    HandleContactSubmit,
    setConDesignation,
    setConDepartment,
    contactError,
    contactClose,
    setContactError,
    setContactShow,
    HandleContactChange,
    contacttemp,
    contactShow,
    HandleConDepChange,
    setContactTemp,
    contact,
    DeleteContact,
    EditContact,
    formErrors,
    setDesignation,
    setCountry,
    country,
    ClearFormValues,
    setFormValues,
    setFormError,
    HandleFormSubmit
}) => {
    const {
        data: departmentdata,
        loading: departmentLoading,
        error: departmentError,
    } = FetchData("department");

    const [activeTab, setActiveTab] = useState("branding");

    return (
        <>
            <div class="card header-card">
                <div className='card-body'>
                    <div className='row'>
                        <div className='col-12'>
                            <div className='card mb-2 general-info-card'>
                                <div className="card-header">
                                    <h2>General Information</h2>
                                </div>
                                <div className='card-body'>
                                    <div className='row'>
                                        <div className='col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2'>
                                            <div className='row'>
                                                <div className='col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2'>
                                                    <div>
                                                        <label>Company Name <span className='mandatory'>*</span></label>
                                                        <input className='form-control' name="companyName" value={formValues?.companyName} type="text" placeholder={PlaceHolder.COMPANY_NAME} onChange={HandleFormChange}></input>
                                                        {formErrors?.companyName && <p className="form-error">{formErrors?.companyName}</p>}
                                                    </div>
                                                </div>
                                                <div className='col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2'>
                                                    <div>
                                                        <label>Company Code <span className='mandatory'>*</span></label>
                                                        <input className='form-control' name="companyCode" value={formValues?.companyCode} type="text" placeholder={PlaceHolder.COMPANY_CODE} onChange={HandleFormChange}></input>
                                                        {formErrors?.companyCode && <p className="form-error">{formErrors?.companyCode}</p>}
                                                        {formErrors?.companyerr && <p className="form-error">{formErrors?.companyerr}</p>}
                                                    </div>
                                                </div>
                                                <div className='col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2'>
                                                    <div>
                                                        <label>Country <span className='mandatory'>*</span></label>
                                                        <DropDownComponent placeholder={PlaceHolder.SELECT_COUNTRY} pageName="company" dpDownName="country" stateData={countrydata} controlName="countrydrp" handleChange={HandleCountryChange} value={country} valueId={formValues?.countryId} setState={setCountry} />
                                                        {formErrors?.country && <p className="form-error">{formErrors?.country}</p>}
                                                    </div>
                                                </div>
                                                <div className='col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2'>
                                                    <div>
                                                        <label>Currency</label>
                                                        <DropDownComponent placeholder={PlaceHolder.SELECT_CURRENCY} pageName="company" dpDownName="currencyCode" controlName="currencyId" stateData={currencydata} handleChange={HandleCurrencyChange} value={currency} valueId={formValues?.defaultCurrencyId} setState={setCurrency} />
                                                    </div>
                                                </div>
                                                <div className='col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2'>
                                                    <div>
                                                        <label>Fax Number </label>
                                                        <input className='form-control' name="fax" value={formValues?.fax} type="text" placeholder={PlaceHolder.FAX} onChange={HandleFormChange}></input>
                                                    </div>
                                                </div>
                                                <div className='col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2'>
                                                    <div>
                                                        <label>Phone Number <span className='mandatory'>*</span></label>
                                                        <PhoneNumberComponent defaultCountry={country?.code} errors={formErrors} setValues={setFormValues} setErrors={setFormError} filedName="phone" values={formValues} />
                                                        {formErrors?.phone && <p className="form-error">{formErrors?.phone}</p>}
                                                    </div>
                                                </div>
                                                <div className='col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2'>
                                                    <div>
                                                        <label>Authorized Person <span className='mandatory'>*</span></label>
                                                        <input className='form-control' name="authorizedPerson" type="text" value={formValues?.authorizedPerson} placeholder={PlaceHolder.NAME} onChange={HandleFormChange}></input>
                                                        {formErrors?.authorizedPerson && <p className="form-error">{formErrors?.authorizedPerson}</p>}
                                                    </div>
                                                </div>
                                                <div className='col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2'>
                                                    <div>
                                                        <label>Position <span className='mandatory'>*</span></label>
                                                        <DropDownComponent placeholder={PlaceHolder.SELECT_POSITION} pageName="company" dpDownName="designation" controlName="designationId" stateData={designationdata} handleChange={HandleDesignationChange} value={designation} valueId={formValues?.designationId} setState={setDesignation} />
                                                        {formErrors?.designation && <p className="form-error">{formErrors?.designation}</p>}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2'>
                                            <div className='col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2'>
                                                <div>
                                                    <label>Email <span className='mandatory'>*</span></label>
                                                    <input className='form-control' name="email" type="text" value={formValues?.email} placeholder={PlaceHolder.EMAIL} onChange={HandleFormChange}></input>
                                                    {formErrors?.email && <p className="form-error">{formErrors?.email}</p>}
                                                </div>
                                            </div>
                                            <div className='col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2'>
                                                <div>
                                                    <label>Website</label>
                                                    <input className='form-control' name="website" type="text" value={formValues?.website} placeholder={PlaceHolder.WEB_SITE} onChange={HandleFormChange}></input>
                                                    {formErrors?.website && <p className="form-error">{formErrors?.website}</p>}
                                                </div>
                                            </div>
                                            <div className='col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2'>
                                                <div>
                                                    <label>Address <span className='mandatory'>*</span></label>
                                                    <textarea className='form-control address-text-area' name="address" value={formValues?.address} placeholder={PlaceHolder.ADDRESS} onChange={HandleFormChange}></textarea>
                                                    {formErrors?.address && <p className="form-error">{formErrors?.address}</p>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        {formValues?.id && (
                                            <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-2 col-sm-12 col-xs-12 mb-2">
                                                <label>Status</label>
                                                <div class="form-group">
                                                    <input
                                                        type="checkbox"
                                                        id="isActive"
                                                        name="isActive"
                                                        value={formValues?.isActive}
                                                        checked={formValues?.isActive}
                                                        onChange={HandleFormChange}
                                                    />
                                                    <label for="isActive" className="mb-0">
                                                        {formValues?.isActive ? "Active" : "Inactive"}
                                                    </label>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* <!-- Single tab nav: Company Branding Assets | Currency | Contacts --> */}
                            <div className="card company-branding-card mb-2">
                                <div className="card-header py-0">
                                    <ul className="nav nav-tabs card-header-tabs" role="tablist">
                                        <li className="nav-item" role="presentation">
                                            <button
                                                type="button"
                                                className={`nav-link ${activeTab === "branding" ? "active" : ""}`}
                                                onClick={() => setActiveTab("branding")}
                                            >
                                                Company Branding Assets
                                            </button>
                                        </li>
                                        {formValues?.id && (
                                            <li className="nav-item" role="presentation">
                                                <button
                                                    type="button"
                                                    className={`nav-link ${activeTab === "currency" ? "active" : ""}`}
                                                    onClick={() => setActiveTab("currency")}
                                                >
                                                    Currency
                                                </button>
                                            </li>
                                        )}
                                        <li className="nav-item" role="presentation">
                                            <button
                                                type="button"
                                                className={`nav-link ${activeTab === "contacts" ? "active" : ""}`}
                                                onClick={() => setActiveTab("contacts")}
                                            >
                                                Contacts
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                                <div className="card-body">
                                    <div className="tab-content" id="companyBrandingTabContent">
                                        {activeTab === "branding" && (
                                            <div className="tab-pane fade show active">
                                                <CompanyDocuments
                                                    HandleImageFileChange={HandleImageFileChange}
                                                    formValues={formValues}
                                                    formErrors={formErrors}
                                                    DeleteImage={DeleteImage}
                                                    showImage={showImage}
                                                />
                                            </div>
                                        )}

                                        {activeTab === "currency" && formValues?.id && (
                                            <div className="tab-pane fade show active">
                                                <CompanyCurrency companyId={formValues?.id} />
                                            </div>
                                        )}

                                        {activeTab === "contacts" && (
                                            <div className="tab-pane fade show active">
                                                <div className="row additional-contact-add-area">
                                                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
                                                        <div className="text-right">
                                                            <button
                                                                type="button"
                                                                className="btn add-new-contact-btn"
                                                                onClick={() => {
                                                                    setContactShow(true);
                                                                    setContactTemp({});
                                                                }}
                                                            >
                                                                <i class="fas fa-plus-square"></i> Add New Contact
                                                            </button>
                                                        </div>
                                                    </div>
                                                    {contact?.map((item, index) => {
                                                        return (
                                                            <div key={index} className="col-xxl-2 col-xl-2 col-lg-3 col-md-4 col-sm-12 col-xs-12 mb-2">
                                                                <div className="added-contact">
                                                                    <div className="contact-edit-options">
                                                                        <i
                                                                            className="far fa-edit"
                                                                            title="Edit"
                                                                            onClick={() => {
                                                                                EditContact(item);
                                                                            }}
                                                                        ></i>
                                                                        <i
                                                                            className="far fa-trash-alt red-tooltip"
                                                                            title="Delete"
                                                                            onClick={() => {
                                                                                DeleteContact(item);
                                                                            }}
                                                                        ></i>
                                                                    </div>
                                                                    <i className="far fa-user-circle"></i>
                                                                    <h5>{item.name}</h5>
                                                                    <span>{item.email}</span>
                                                                    <p>{item.designation}</p>
                                                                    <p>{item.phone}</p>
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* <!-- Save / Cancel buttons --> */}
                            <div className="card">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-3 mb-3">
                                            <div className="save-btns d-flex justify-content-end">
                                                <button className="btn cancel-btn" onClick={ClearFormValues}>
                                                    Cancel
                                                </button>
                                                <button className="btn save-btn" onClick={HandleFormSubmit}>
                                                    {!formValues?.id ? "Save" : "Update"}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CompanyDetails